import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { OfferDetail, UserProfile } from 'types/api'

export type OfferDetailRoleBased<Role extends UserProfile['role']> =
  Role extends 'ADMIN'
    ? OfferDetail
    : Role extends 'LANDLORD'
      ? Omit<
          OfferDetail,
          | 'monthly_advance_prescription"'
          | 'gas'
          | 'electricity'
          | 'internet_tv'
        >
      : Exclude<
          OfferDetail,
          | 'monthly_advance_prescription"'
          | 'gas'
          | 'electricity'
          | 'internet_tv'
          | 'deposit_amount'
          | 'deposit_sum'
          | 'deposit_max_allowed'
          | 'application_info'
          | 'roommates_info'
          | 'expenses'
        >

export const offersQueryKey = ['offers-detail']

export function useOffersDetail<Role extends UserProfile['role']>(id?: string) {
  async function getOffersDetail() {
    const response = await apiClient.get<OfferDetailRoleBased<Role>>(
      `${SNA_PREFIX}offers/${id}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getOffersDetail,
    queryKey: [...offersQueryKey, id],
    enabled: !!id
  })
}
